

































import { Vue, Component, Prop } from 'vue-property-decorator';
import { IconSize, ParagraphSize } from '@getaccept/lib-ui';
import type { ChatComment } from '../types/chat-comment';

@Component({
  data: () => ({
    ParagraphSize,
    IconSize,
  }),
})
export default class ChatMessageSender extends Vue {
  @Prop() comment: ChatComment;
  @Prop() name: string;
  @Prop() fullTimestamp: string;
  @Prop() first: boolean;
  @Prop() last: boolean;
  @Prop() showDelete: boolean;

  showMessageTimestamp = false;

  hideTimestamp() {
    this.showMessageTimestamp = false;
  }
}
